let language = {
    ORDERS_ERROR_TIPS_FORM: "The Start date must be less than the end date",
    ORDERS_ERROR_TIPS_NULL: "orderListForm is null",
    ORDERS_ERROR_TIPS_CANCEL_TITLE: "Success",
    ORDERS_ERROR_TIPS_CANCEL_CONTENT: "Cancel Order Success",
    ORDERS_ERROR_TIPS_DOWNLOAD_TITLE: "Download invoice",
    ORDERS_ERROR_TIPS_DOWNLOAD_CONTENT: "No item was selected",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL: "Download invoice failed",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL_TIPS: "Opps, the invoice information is not found. Please check whether your order status meets the conditions to download the invoice.",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL_TIPS_2: "Opps, There are some orders without invoice information. You can click [Ok] to continue downloading the invoice, or click [Cancel] to stop publishing the download.",
}

export { language }